<script>
export default {
}

</script>

<template>
</template>

<style scoped lang="scss">
</style>